import { render, staticRenderFns } from "./PageHeaderTabs.vue?vue&type=template&id=b73cb776&"
import script from "./PageHeaderTabs.vue?vue&type=script&lang=js&"
export * from "./PageHeaderTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports